var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrendUp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.31693 3.85346C7.66721 3.41583 8.33287 3.41582 8.68314 3.85346L14.2378 10.7968C14.827 11.5334 14.3031 12.6248 13.3599 12.6249H2.64017C1.75603 12.6247 1.24028 11.6661 1.66458 10.9394L1.76224 10.7968L7.31693 3.85346Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrendUp);
export default ForwardRef;